import { render, staticRenderFns } from "./form-for-initiative.vue?vue&type=template&id=687a9625&lang=pug&"
import script from "./form-for-initiative.vue?vue&type=script&lang=js&"
export * from "./form-for-initiative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports